import CollectionDataGrid from '@/components/CollectionDataGrid'
import { pbUpsert, useCollection, usePaginatedCollection } from '@/pb'
import { arrayToObject, useInputState } from '@/utils'
import { Button, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, LinearProgress, MenuItem, Select, TextField } from '@mui/material'
import { useState } from 'react'

const Editor = ({ row, onClose }) => {
    const [name, setName] = useInputState(row?.name)
    const [gymId, setGymId] = useInputState(row?.gymId || 'none')
    const [gyms, gymsLoaded] = useCollection('gyms')

    if (!gymsLoaded) return <LinearProgress />

    return <>
        <DialogTitle>Залы</DialogTitle>
        <DialogContent className="editorForm">
            <TextField label={fields.name.headerName} value={name} onChange={setName} />
            <FormControl>
                <InputLabel id="gymId">{fields['expand.gymId'].headerName}</InputLabel>
                <Select
                    labelId="gymId"
                    value={gymId}
                    label={fields['expand.gymId'].headerName}
                    onChange={setGymId}
                >
                    <MenuItem value="none"><em>Не выбрано</em></MenuItem>
                    {Object.entries(gyms).map(([id, { name }]) =>
                        <MenuItem value={id}>{name}</MenuItem>
                    )}
                </Select>
            </FormControl>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} >Отмена</Button>
            <Button onClick={() => pbUpsert('rooms', { id: row?.id, name, gymId: gymId === 'none' ? '' : gymId }).then(onClose)} variant="contained">Сохранить</Button>
        </DialogActions>
    </>
}

const columns = [
    { field: 'name', headerName: 'Название', width: 300 },
    {
        field: 'expand.gymId', headerName: 'Тренажерка', width: 300, renderCell: ({ row }) => {
            const gym = row?.expand?.gymId
            return <span>{gym?.name || '—'}</span>
        },
    },
]
const fields = arrayToObject(columns, 'field')

export default function Rooms({ title }) {
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    })

    const {
        records: rooms,
        totalItems,
        loaded,
    } = usePaginatedCollection('rooms', {
        page: paginationModel.page + 1,
        perPage: paginationModel.pageSize,
        sort: '-created',
        expand: 'gymId'
    })


    return <>
        <CollectionDataGrid
            collectionName={title}
            collection={rooms}
            columns={columns}
            loading={!loaded}
            editor={Editor}
            serverPagination={true}
            rowCount={totalItems}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
        />
    </>

}